import * as React from 'react';

import { DataTable, DataRow, DataCell } from '../../basic/DataTable';
import '../../../styles/Forms.scss';
import './entities/generic/StageActionToolbar.scss';
import './entities/generic/TierSummary.scss';
import { migrateEntities } from './Constants';

interface ConversionSummaryTableState {}

class StatisticsViewModel {
    entityType?: string | undefined;
    entityName?: string | undefined;
    mapped?: number | undefined;
    notMapped?: number | undefined;
    isDropped?: number | undefined;
    total?: number | undefined;
    status?: any | undefined;
    statuses?: any | undefined;
    sectionId?: string | undefined;
    tier?: string | undefined;
    isMappable?: boolean | undefined;
}

interface ConversionSummaryTableProps {
    conversionId: string,
    items: StatisticsViewModel[];
    isMappable: any;
    isMappableToggle: any;
    status1: any;
    toEntity: any;
    handleHover: (status: any, packageName: string) => void;
}

export default class ConversionSummaryTable extends React.Component<ConversionSummaryTableProps, ConversionSummaryTableState>{
 
    constructor(props: ConversionSummaryTableProps) {
        super(props);
        this.state = {}
    }

    public render() {
        const items = this.props.items;
        const mappable = !this.props.isMappable ? "Show All" : "Show Mappable"
        return (
            <DataTable>
                <thead>
                    <tr>
                        <th className="text-column">Entity</th>
                        <th className="number-column">Mapped</th>
                        <th className="number-column">UnMapped</th>
                        <th className="number-column">Excluded</th>
                        <th className="text-column">Status</th>
                        <th className="toggle-column"><label className="switch"><input type="checkbox" readOnly checked={this.props.isMappable} onClick={this.props.isMappableToggle} /> <span className="slider round"></span></label>{mappable}</th>
                    </tr>
                </thead>
                <tbody className={this.props.status1 !== null ? "statusSummary" : "summary"}>
                    {items.map((item, index) => {
                        const migrateName = migrateEntities.filter(me => me.sectionId === item.sectionId)
                        const packageName = migrateName[0] ? migrateName[0].packageName : 'packageName'
                        return (<DataRow id={index.toString()} className={(item.mapped !== null && item.notMapped !== null) ? 'summaryLink' : ''} key={index}>
                            <DataCell className="text-column-cs" onClick={() => { if (item.mapped !== null && item.notMapped !== null) this.props.toEntity(item) }}>{item.entityName !== undefined ? item.entityName : item.entityType}</DataCell>
                            {item.mapped !== null && item.notMapped !== null && item.isMappable ?
                                <>
                                    <DataCell className="number-column-cs summaryLink" onClick={() => { this.props.toEntity(item) }}>{item.mapped}</DataCell>
                                    <DataCell className="number-column-cs summaryLink" onClick={() => { this.props.toEntity(item) }}>{item.notMapped}</DataCell>
                                    <DataCell className="number-column-cs summaryLink" onClick={() => { this.props.toEntity(item) }}>{item.isDropped}</DataCell>
                                </> :
                                item.mapped !== null && item.notMapped !== null && !item.isMappable ?
                                    <>
                                        <DataCell className="number-column-cs summaryLink" onClick={() => { this.props.toEntity(item) }}></DataCell>
                                        <DataCell className="number-column-cs summaryLink" onClick={() => { this.props.toEntity(item) }}>{'No Mapping Required'}</DataCell>
                                        <DataCell className="number-column-cs summaryLink" onClick={() => { this.props.toEntity(item) }}></DataCell>
                                    </> :
                                    <>
                                        <DataCell className="number-column-cs"></DataCell>
                                        <DataCell className="number-column-cs">{'No Source Data'}</DataCell>
                                        <DataCell className="number-column-cs"></DataCell>
                                    </>}
                            {item.statuses ?
                                <DataCell className="text-column-cs" onClick={() => { if (item.mapped !== null && item.notMapped !== null) this.props.toEntity(item) }}>{item.statuses!.map((i: any, index: number) => <div key={index}>{i}</div>)}</DataCell> :
                                <DataCell className="text-column-cs" onClick={() => { if (item.mapped !== null && item.notMapped !== null && item.status.props.children[1].props.color.toString() !== "danger") this.props.toEntity(item) }}>
                                    <div onClick={() => this.props.handleHover(item.status, packageName!)} className='pointer'>
                                        {item.status}
                                    </div>
                                </DataCell>}
                            <DataCell className="toggle-column-cs" onClick={() => { if (item.mapped !== null && item.notMapped !== null) this.props.toEntity(item) }}></DataCell>
                        </DataRow>)
                    })}
                </tbody>
            </DataTable>
        )
    }
}